
//################### SELECT OR UNSELECT ALL GRID ROW BLOCK START #############################
///*******PURPOSE:  THIS METHOD IS USED TO SELECT OR UN SELECT ALL GRID ROWS
///*******CREATED BY: Kranthi Kumar G
///*******CREATED DATE: MAR 11 2016
///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
var emrGridSelectOrUnselectAll = function (gridID, checkState) {
	var grid = $("#" + gridID).data("kendoGrid"); //getting grid instance based on grid id
	var items = grid.dataSource.data(); //getting data source of the grid

	if (!hasValue(checkState)) return;

	for (var i = 0; i < items.length - 1; i++) {
		//changing item select check-state to given
		items[i].selected = checkState;
	}
	if (hasValue(grid.thead.find("input:checkbox")) && grid.thead.find("input:checkbox").length > 0) {
		//changing grid header check box check-state
		grid.thead.find("input:checkbox")[0].checked = checkState;
	}
};
//################### SELECT OR UNSELECT ALL GRID ROW BLOCK END #############################

//select all check box onClick event handler, Which is used to handle select/deselect all the checkboxes existing in grid rows
var toggleSelectAllForJS = function (gridID, obj) {
	var grid = $("#" + gridID).data("kendoGrid"); //getting grid instance based on grid id
	var items = grid.dataSource.data(); //getting data source of the grid

	//looping each item and set selected flag to true/false
	items.forEach(function (item) {
		item.selected = obj.checked; //setting select all checkbox checked state to the item.selected property
		if (item.selected) {

			grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
		}
		else
			grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
	});
	//upgrade to 1.6.0
	//var ehrTimeOut = $timeout(function () {
	//    $scope.$apply();
	//});

	//commented for upgrade to 1.6.0
	$scope.$apply();
	// grid.dataSource.data(items); //refreshing data source

	if (grid.options.gridselectallstatus)
		grid.options.gridselectallstatus(false);
};
//this method is useful in single selection allowing in the grid on change event in the grid
var toggleSelectOnChange = function (ev, syncNotRequired) {

	var grid = ev.sender; //getting grid instance//getting grid instance
	var items = grid.dataSource.data(); //getting data source of the grid
	var isMultiSelect = grid.options.selectable;
	var chkColcount = 0;//defaults
	if (hasValue(grid._group) && grid._group == true) {
		chkColcount = 1;
	}

	if (grid.options.makeslectallbysingleselection) { // if makeslectallbysingleselection is given as true then make checked is false in select all check box 
		grid.thead.find(".selectAllChkBox").prop('checked', false);
		if (grid.options.gridselectallstatus)
			grid.options.gridselectallstatus(false);
	}

	if (isMultiSelect == "single" || isMultiSelect == "single row") {

		grid.tbody.find("tr").each(function () {
			var $this = $(this),
				ckbox,
				selected,
				currentItem;
			ckbox = $this.find('td:eq(' + chkColcount + ') input');
			selected = ckbox.prop("checked");
			currentItem = grid.dataSource.getByUid($this.attr("data-uid"));
			//condition added by mahesh p on 03/28/2017 since for grouping grid not getting the item
			if (currentItem) {
				if ($this.hasClass("k-state-selected")) {
					ckbox.prop("checked", !selected);
					currentItem.selected = true;
				}
				else {
					ckbox.prop("checked", false);
					currentItem.selected = false;
				}
			}
		});

	}
	//multiple selection
	else {
		// grid.tbody.find("tr").each(function () {
		var $this = grid.select(),//$(this),//current selected item in grid
			ckbox,
			selected,
			currentItem;
		if ($this.hasClass("k-state-selected")) {
			ckbox = $this.find('td:eq(' + chkColcount + ') input');
			selected = ckbox.prop("checked");
			ckbox.prop("checked", !selected);
			currentItem = grid.dataSource.getByUid($this.attr("data-uid"));
			//condition added by mahesh p on 03/28/2017 since for grouping grid not getting the item
			if (currentItem)
				currentItem.selected = !selected;
		}
		// });
	}

	if (!syncNotRequired)
		grid.dataSource.sync();

	//if (isMultiSelect == "single" || isMultiSelect == "single row") {
	//    //looping each item and set selected flag to true/false
	//    items.forEach(function (item) {
	//        if (item.uid == currentRow.uid) {
	//            item.selected = true; //setting select all checkbox checked state to the item.selected property                           
	//            grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
	//        }
	//        else {
	//            item.selected = false; //setting select all checkbox checked state to the item.selected property                           
	//            grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
	//        }
	//    });
	//}
	//else {//multiple case
	//    if (currentRow.selected) {
	//        currentRow.selected = false;
	//        grid.table.find("tr[data-uid='" + currentRow.uid + "']").removeClass("k-state-selected");//removing the state selected
	//    }
	//    else {
	//        currentRow.selected = true;
	//        grid.table.find("tr[data-uid='" + currentRow.uid + "']").addClass("k-state-selected");//adding the state selected
	//    }
	//}
	////grid.refresh();
	//$scope.$apply();//applying the changes in the angular scopes
	////grid.dataSource.read();
	////grid.dataSource.data(items); //refreshing data source
};
//################### COPY CONTENT INSIDE IFRAME TO CLIP BOARD BLOCK END ############################################
//PURPOSE: THIS METHOD IS USEFUL IN GETTING THE NOT SELECTED CHECKBOXES ROWS FROM THE GRID WITH THEIR UID'S AND SELECTED ROWS FROM THE GRID
// CREATED BY: AKBAR
// CREATED ON: 03/26/2019
function getNotSelectedRowsFromGridGlobal(grid, chkColcount) {

    if (!hasValue(grid)) return;

    var NotCheckedRowsUids = [];//FOR MAINTAINING THE NOT CHECKED ITEMS IN THE GRID
    var NotselectedRows = [];

    //IN SOME CASES THE CHECK BOX COLUMN  IS NOT THE FIRST COLUMN
    if (!hasValue(chkColcount)) {
        var chkColcount = 0;//DEFAULTS

        if (hasValue(grid._group) && grid._group == true) {
            chkColcount = 1;
        }
    }

    if ((hasValue(grid.options.showCheckBoxColumn) && grid.options.showCheckBoxColumn) || $(grid.table.find("tr").find('td:eq(' + chkColcount + ') input[type="checkbox"]')).length > 0) {

        if (!hasValue(grid.table)) return NotselectedRows;

        var items = $(grid.table.find("tr").find('td:eq(' + chkColcount + ') input[type="checkbox"]'));///.parents("tr");

        if (hasValue(items) && items.length > 0) {
            //getting the checked row items uid's
            items.each(function (index, item) {

                if (hasValue(item) && hasValue(item.checked) && !item.checked) {

                    var currentRow = angular.element(item).parents("tr");

                    if (hasValue(currentRow) && currentRow.length > 0) {

                        var curUid = currentRow[0].getAttribute("data-uid");

                        NotCheckedRowsUids.push({ uid: curUid });//PUSHING THE NOT CHECKED ROW UID'S

                        if (hasValue(curUid)) {
                            var curRowItem = grid.dataSource.getByUid(curUid);
                            if (hasValue(curRowItem))
                                NotselectedRows.push(curRowItem);
                        }
                    }
                }
            });
        }
    }
    return NotselectedRows;//RETURNING THE CHECKED SELECTED ROWS IN THE GRID
}

//this method is useful in getting the selected checkboxes rows from the grid with their UID's and selected rows from the grid
var getSelectedRowsFromGrid = function (grid, chkColcount, IsLazyBindingGrid) {
	return getSelectedRowsFromGridGlobal(grid, chkColcount, IsLazyBindingGrid);
};

//this method is useful in getting the selected checkboxes rows from the grid with their UID's and selected rows from the grid
var getNotSelectedRowsFromGrid = function (grid, chkColcount) {
    return getNotSelectedRowsFromGridGlobal(grid, chkColcount);
};

//##########################################################################################################################################
////this method is used to move selected row from one grid to another
//moveRowFromSourceToDestination = function (event, sourceGrid, destinationGrid) {
//    destinationGrid.dataSource.add(sourceGrid.dataSource.getByUid($(event.currentTarget).closest("tr").attr('data-uid')));
//    sourceGrid.removeRow($(event.currentTarget).closest("tr"));
//    //$scope.$apply();
//};

//this method is used to move selected row from one grid to another
var moveRowFromSourceToDestination = function (event, sourceGrid, destinationGrid, ColumnToRemoveSpecialCharacters) {

	//Get the Row to Be add in Denstination Grid
	var selectedRow = sourceGrid.dataSource.getByUid($(event.currentTarget).closest("tr").attr('data-uid'))

	//Replace the Special chars from the Newly Added List
	if (hasValue(ColumnToRemoveSpecialCharacters) && ColumnToRemoveSpecialCharacters == "EasyFormXMLGenerationNodeName") {
		selectedRow.EasyFormXMLGenerationNodeName = selectedRow.EasyFormXMLGenerationNodeName.replace(" ", "").replace(">", "").replace("<", "").replace('"', "").replace("'", "").replace(" ", "").replace(" ", "");
	}

	destinationGrid.dataSource.add(selectedRow);
	sourceGrid.removeRow($(event.currentTarget).closest("tr"));
	//$scope.$apply();
};
//##########################################################################################################################################

//this method is useful in moving the selected row from the source to destination
var moveSelectedRowFromSourceToDestination = function (sourceGrid, destinationGrid) {
	var selected = sourceGrid.select();
	// upgrade to angular 1.7.2
	if (!hasValue(selected) && hasValue(selectedItemToMove)) {
		selected = selectedItemToMove;
	}
	if (selected.length > 0) {
		var items = [];
		$.each(selected, function (idx, elem) {
			items.push(sourceGrid.dataItem(elem));
		});
		var fromDS = sourceGrid.dataSource;
		var toDS = destinationGrid.dataSource;
		$.each(items, function (idx, elem) {
			toDS.add($.extend({}, elem));
			fromDS.remove(elem);
		});
		toDS.sync();
		fromDS.sync();
	}
};

//this method is used to Select the grid row when clicked on "Command Template"
var selectGridRowBasedOnCommandTemplateEvent = function (e, grd) {
	grd.select($(e.currentTarget).closest("tr"));
	//$(e.currentTarget).closest("tr").addClass("k-state-selected");
	//grid.select(grid.element.data("kendoGrid").tbody.find("tr[data-uid='" + e.dataItem.uid + "']"));
};

var makePreviewColumnOnBound = function (event) {

	if (event.sender.dataSource.data().length > 0) {
		makePreviewColumnOnBoundWidget(event.sender);
	}

};


var makePreviewColumnOnBoundWidget = function (sender) {

	if (sender.dataSource.data().length > 0) {

		//                    var visibleCount = 0;
		//                    $.each(event.sender.columns, function (index, item) {
		//                        if (item.hidden == null || item.hidden == undefined || item.hidden == false) {
		//                            visibleCount++;
		//                        }
		//                    });

		//                    if (event.sender.options.showCheckBoxColumn) {
		//                        visibleCount--;
		//                    }
		var visibleCount = sender.columns.length;

		sender.tbody.find("tr").each(function () {
			var $this = $(this);
			var dataItem = sender.dataSource.getByUid(($this).attr('data-uid'));
			if (hasValue(dataItem)) {
				if (sender.options.previewColumn != null && sender.options.previewColumn != undefined && sender.options.previewColumn != "") {
					if (dataItem[sender.options.previewColumn] != null && dataItem[sender.options.previewColumn] != undefined && dataItem[sender.options.previewColumn] != "") {
						// $("<tr class='k-state-disabled' previewcolumn='true' readonly span style='color : black;background-color : yellow !important;' readonly><td colspan=" + visibleCount + ">" + dataItem[sender.options.previewColumn] + "</td></tr>").insertAfter($this);
						/**
						 *@ModifiedBy:P.Lakshmi Ramya
						 *@Modification:Removed k-state-disabled class
						 *@Reason: Because of that class we got an issue in messages.As the div is in diabled state we are unable to scroll if we get an excess data
						 */
						//$("<div class='k-state-disabled k-emr-previewColumn' previewcolumn='true' readonly span style='color : black;background-color : yellow !important;width : " + $this.width() + "px;' readonly>" + dataItem[sender.options.previewColumn] + "</div>").insertAfter($this);
						$("<div class='k-emr-previewColumn' previewcolumn='true' readonly span style='color : black;background-color : yellow !important;width : " + $this.width() + "px;' readonly>" + dataItem[sender.options.previewColumn] + "</div>").insertAfter($this);
					}
				}
			}
		});

		//$(".k-state-disabled").on("click", function (e) {
		//    //makeUnselectablePreviewColumn();
		//    e.preventDefault();
		//    e.stopImmediatePropagation();
		//    e.stopPropagation();  //stopping the previous click events  
		//});
	}

};

var hidePreviewColumn = function (sender) {
	if (sender.dataSource.data().length > 0) {
		sender.tbody.find(".k-emr-previewColumn").hide();
	}
};

var showPreviewColumn = function (sender) {
	if (sender.dataSource.data().length > 0) {
		sender.tbody.find(".k-emr-previewColumn").show();

	}

	makePreviewColumnOnBoundWidget(sender);
};

var RemovePreviewColumn = function (sender) {
	if (hasValue(sender) && hasValue(sender.dataSource) && hasValue(sender.dataSource.data()) && sender.dataSource.data().length > 0) {
		sender.tbody.find(".k-emr-previewColumn").remove();
	}
};


//this method is useful in single selection allowing in the grid on change event in the grid
var toggleSelectOnChangeNew = function (ev) {

	var grid = ev.sender; //getting grid instance//getting grid instance
	var items = grid.dataSource.data(); //getting data source of the grid
	var isMultiSelect = grid.options.selectable;
	var chkColcount = 0;//defaults
	if (hasValue(grid._group) && grid._group == true) {
		chkColcount = 1;
	}

	if (grid.options.makeslectallbysingleselection) { // if makeslectallbysingleselection is given as true then make checked is false in select all check box 
		grid.thead.find(".selectAllChkBox").prop('checked', false);
		if (grid.options.gridselectallstatus)
			grid.options.gridselectallstatus(false);
	}

	if (isMultiSelect == "single" || isMultiSelect == "single row") {

		grid.tbody.find("tr").each(function () {
			var $this = $(this),
				ckbox,
				selected;

			ckbox = $this.find('td:eq(' + chkColcount + ') input');
			selected = ckbox.prop("checked");

			if ($this.hasClass("k-state-selected")) {
				ckbox.prop("checked", !selected);
			}
			else {
				ckbox.prop("checked", false);
			}

		});

	}
	//multiple selection
	else {
		// grid.tbody.find("tr").each(function () {
		var $this = grid.select(),//$(this),//current selected item in grid
			ckbox,
			selected;

		if ($this.hasClass("k-state-selected")) {
			ckbox = $this.find('td:eq(' + chkColcount + ') input');
			selected = ckbox.prop("checked");
			ckbox.prop("checked", !selected);
		}
		// });
	}



};




//this method is useful in changing the display sequence of the rows in the grid 
var kendoGridChangeDisplaySequenceOfRows = function (grid, displaySequenceMoveType) {

	if (!hasValue(grid) || !hasValue(displaySequenceMoveType)) return;


	var currentDataItem = grid.dataItem(grid.select());

	if (!hasValue(currentDataItem))
		return;

	var idx = grid.dataSource.indexOf(currentDataItem);

	if (displaySequenceMoveType == EMRGridDisplaySequence.MOVEDOWN) {
		if (hasValue(grid.select().next())) {
			var targetDatItem = grid.dataItem(grid.select().next());
			var targetIdx = idx + 1;
		}
	}
	if (displaySequenceMoveType == EMRGridDisplaySequence.MOVEUP) {
		if (hasValue(grid.select().prev())) {
			var targetDatItem = grid.dataItem(grid.select().prev());
			var targetIdx = idx - 1;
		}
	}

	if (hasValue(currentDataItem) && hasValue(targetDatItem)) {

		grid.dataSource.remove(targetDatItem);
		grid.dataSource.insert(idx, targetDatItem);
		grid.dataSource.remove(currentDataItem);
		grid.dataSource.insert(targetIdx, currentDataItem);
		grid.select(grid.table.find("tr:eq(" + targetIdx + ")"));

		////SCROLLING BASED ON MOVE UP DISPLAY SEQUENCE BUTTON.
		var row = grid.table.find("tr:eq(" + targetIdx + ")");
		// row[0].scrollIntoView();
		grid.content.scrollTop(0); // we HAVE to reset the scroll first.
		//grid.content.scrollTop(row.offset().top - grid.content.offset().top - 45);

        if (hasValue(row.offset()))   //The offset() method set or returns the offset coordinates for the selected elements, relative to the document.
        {
            grid.content.scrollTop(row.offset().top - grid.content.offset().top - 45);
        }
		//this.scrollIntoViewIfNeeded(); // Scroll to Focussed Item
	}

};


//************************************************************************************************************
//** Description: The following are a set of functions, for implementing checkbox functionality              *
//**              in a variety of environments like emr-grid, and dynamic grids, and                         *
//**              on a variety of devices like desktops and ipads and mobiles.                               *
//**---------------------------------------------------------------------------------------------------------*
//** Functions:   genEMRGridTemplates, toggleSelectAll, toggleSelectSingle                                   *
//**---------------------------------------------------------------------------------------------------------*
//** Date:        27 sep 2018; pgpatrudu                                                                     *
//**---------------------------------------------------------------------------------------------------------*
//** Remarks:     The reason for this exercise is provide a uniform code base for both emr-grid and          *
//**              dynamic grids, which define their own grid options.                                        *
//**              The code in these functions has no dependency on angularJs and are purely based on jquery. *
//**              These functions are used by emr-grid internally.                                           *
//**---------------------------------------------------------------------------------------------------------*
//** Usage:       IF YOU HAVE A DYNAMIC GRID JUST CALL THESE FUNCTIONS FROM YOUR ANGULAR FUNCTIONS.          *
//**              1) call genEMRGridTemplates to get row and hdr templates automatically for desktop or ipad.*
//**                 pass the grid id with emr_guid as parm to this function, to avoid duplicate id's across *
//**                 tabs.                                                                                   *
//**              2) push the templates into your grid options                                               *
//**              3) delegate events to these functions, as shown below                                      *
//**                    $scope.toggleSelectAll = function (ev) {                                             *
//**                        toggleSelectAllHandler(ev);                                                      *
//**                    };                                                                                   *
//**                                                                                                         *
//**                    $scope.toggleSelectSingle = function (ev, currentRow) {                              *
//**                        toggleSelectSingleHandler(ev, currentRow);                                       *
//**                    };                                                                                   *
//**                                                                                                         *
//************************************************************************************************************

var genEMRGridTemplates = function (id) {

	var emrGridTemplates = {
		rowTemplate: "",
		hdrTemplate: ""
	};

	//// create templates according to device type (desktop or mobile) 
	//var EmrGridTemplates.rowTemplate = "";
	//var EmrGridTemplates.hdrTemplate = "";

	// desktop templates
	if (!EHRisMobile.any()) {
		emrGridTemplates.rowTemplate = "<span style='padding : 6px;' class='text-center'><input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/></span>";
		emrGridTemplates.hdrTemplate = "<span style='padding : 6px;' class='text-center'><input type='checkbox' class='selectAllChkBox'  ng-click='toggleSelectAll($event)' /></span>";
	}


	// mobile templates
	if (EHRisMobile.any()) {
		emrGridTemplates.rowTemplate = "<div id='" + id + "_touchSurface1' kendo-touch k-on-touchstart='toggleSelectSingle(kendoEvent,dataItem);'><input type='checkbox' ng-model='dataItem.selected' /></div>";
		emrGridTemplates.hdrTemplate = "<div id='" + id + "_touchSurface2' kendo-touch k-on-touchstart='toggleSelectAll(kendoEvent);'><input type='checkbox' class='selectAllChkBox' /></div>";
	}

	return emrGridTemplates;

}

// selectAll checkbox event handler
var toggleSelectAllHandler = function (ev) {

	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu - - - begin

	// var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance

	var grid = {};
	var eventObj;
	var value = false;

	if (!EHRisMobile.any()) {
		grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
		eventObj = ev.target;

		if (!hasValue(ev.target.checked)) {
			value = false;
		} else {
			value = ev.target.checked;
		}
	}

    if (EHRisMobile.any()) {

        //#region COMMENTED BY AKBAR TO RESOLOVE  undefined is not an object (evaluating 'e.event.target') ERROR
		//grid = $(ev.event.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
		//eventObj = ev.event.target;

		////value = $scope.toggleSelectAllValue.selected;
		////value = !value;
		////$scope.toggleSelectAllValue.selected = value;

		//if (!hasValue(ev.event.target.checked)) {
		//	value = false;
		//} else {
		//	value = ev.event.target.checked;
		//	value = !value;
		//	ev.event.target.checked = value;
		//}
        // #endregion

        //#region ADDED BY AKBAR TO RESOLOVE  undefined is not an object (evaluating 'e.event.target') ERROR
        if (ev && ev.event && ev.event.target) {
            grid = $(ev.event.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
            eventObj = ev.event.target;
        } else {
            grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
            eventObj = ev.target;
        }

        if (!eventObj.checked) {
			value = false;
		} else {
            value = eventObj.checked;
			value = !value;
            eventObj.checked = value;
		}
        // #endregion
	}
	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu - - - end

	var focusRequired = grid.options.focusRequired;
	var items = grid.dataSource.data(); //getting data source of the grid
	//############# previous version &&&&&&&&&&&&&&&&&&&&&&&&&&
	// let selectSelector = "";
	// let deselectSelector = "";
	// //looping each item and set selected flag to true/false
	// items.forEach(function (item) {

	// 	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu 
	// 	// item.selected = ev.target.checked; //setting select all checkbox checked state to the item.selected property
	// 	item.selected = value;
	// 	const selector = "tr[data-uid='" + item.uid + "']";
	// 	if (item.selected && hasValue(focusRequired) && focusRequired) {
	// 		selectSelector = selectSelector ? selectSelector + ", " + selector : selector;
	// 		//grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
	// 	}
	// 	else
	// 		deselectSelector = deselectSelector ? deselectSelector + ", " + selector : selector;
	// 		//grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected

	// });
	// if(selectSelector)
	// 	grid.table.find(selectSelector).addClass("k-state-selected");
	// if(deselectSelector)
	// 	grid.table.find(deselectSelector).removeClass("k-state-selected");
	//############# previous version end &&&&&&&&&&&&&&&&&&&&&&&&&&
	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu
	//if (grid.options.gridselectallstatus)
	//    grid.options.gridselectallstatus(ev.target.checked);
	//######### New version #########
	let rowCached = {};
	grid.table.find("tr[data-uid]").each(function () {
		rowCached[this.getAttribute('data-uid')] = this;
	});
	items.forEach(function (item) {
		item.selected = value;
		const row = rowCached[item.uid];
		if (!row) return;
		if (item.selected && hasValue(focusRequired) && focusRequired)
			row.classList.add('k-state-selected');
		else
			row.classList.remove('k-state-selected');
	});
	//######### New version end #########
	if (grid.options.gridselectallstatus) {
		grid.options.gridselectallstatus(value);
	}


	//var checkbox = $(this);
	//        grid.table.find("tr")
	//            .find("td:first input")
	//            .attr("checked", checkbox.is(":checked"))
	//            .trigger("change");

}

// selectSingle checkbox event handler
var toggleSelectSingleHandler = function (ev, currentRow) {

	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu - - - begin
	// var grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance

	var grid = {};
	var eventObj;

	if (!EHRisMobile.any()) {
		grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
		eventObj = ev.target;
	}

	if (EHRisMobile.any()) {
		if (hasValue(ev) && hasValue(ev.event) && hasValue(ev.event.target)) {
			grid = $(ev.event.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
			eventObj = ev.event.target;
		} else {
			grid = $(ev.target).closest("[kendo-grid]").data("kendoGrid"); //getting grid instance
			eventObj = ev.target;
		}
	}
	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu - - - end


	var isMultiSelect = grid.options.selectable;
	var items = grid.dataSource.data(); //getting data source of the grid

	if (grid.options.makeslectallbysingleselection) { // if makeslectallbysingleselection is given as true then make checked is false in select all check box 
		grid.thead.find(".selectAllChkBox").prop('checked', false);
		if (grid.options.gridselectallstatus)
			grid.options.gridselectallstatus(false);
	}

	if (grid.options.triggerChangeOnCheckBoxWithoutToggle) {
		grid.table.find(".k-state-selected").removeClass("k-state-selected");

		//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu
		//$(ev.target).prop("checked", !($(ev.target).prop('checked')));
		//grid.select($(ev.target).closest("tr"));
		//$(ev.target).prop("checked", !($(ev.target).prop('checked')));
		//$(ev.target).closest("tr").addClass("k-state-selected");

		grid.select($(eventObj).closest("tr"));
		$(eventObj).closest("tr").addClass("k-state-selected");

		return;
	}

	if (grid.options.triggerChangeOnCheckBox) {
		grid.table.find(".k-state-selected").removeClass("k-state-selected");

		//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu
		//$(ev.target).prop("checked", !($(ev.target).prop('checked')));
		//grid.select($(ev.target).closest("tr"));
		//$(ev.target).prop("checked", !($(ev.target).prop('checked')));
		//$(ev.target).closest("tr").addClass("k-state-selected");

		$(eventObj).prop("checked", !($(eventObj).prop('checked')));
		grid.select($(eventObj).closest("tr"));
		$(eventObj).closest("tr").addClass("k-state-selected");

		return;
	}

	if (isMultiSelect == "single" || isMultiSelect == "single row") {
		//looping each item and set selected flag to true/false
		items.forEach(function (item) {
			if (item.uid == currentRow.uid) {
				if (item.selected) {
					item.selected = false;
					grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
				}
				else {
					item.selected = true; //setting select all checkbox checked state to the item.selected property 
					//setTimeout(function () { $(ev.target).prop("checked", true); }, 1);
					//grid.select(grid.table.find("tr[data-uid='" + item.uid + "']"))

					if (!hasValue(grid.options.isLockedGrid))
						grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
				}

			}
			else {
				item.selected = false; //setting select all checkbox checked state to the item.selected property                           
				grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
			}
		});
	}
	else {//multiple case
		let rowCached = {};
		
		grid.table.find("tr[data-uid]").each(function () {
			rowCached[this.getAttribute('data-uid')] = this;
		});

		items.forEach(function (item) {

			const row = rowCached[item.uid];
			if (!row) return;
			if (item.uid == currentRow.uid) {
				if (item.selected) {
					item.selected = false;
					row.classList.remove('k-state-selected');
					//grid.table.find("tr[data-uid='" + item.uid + "']").removeClass("k-state-selected");//removing the state selected
				}
				else {

					//setTimeout(function () { $(ev.target).prop("checked", true); }, 1);

					item.selected = true; //setting select all checkbox checked state to the item.selected property 
					//grid.select(grid.table.find("tr[data-uid='" + item.uid + "']"))
					// if (!hasValue(grid.options.isLockedGrid))
					// 	grid.table.find("tr[data-uid='" + item.uid + "']").addClass("k-state-selected");//adding the state selected
					if (!hasValue(grid.options.isLockedGrid))
						row.classList.add('k-state-selected');;//adding the state selected
				}

			}
			else {
				//item.selected = false; //setting select all checkbox checked state to the item.selected property                           
				row.classList.remove('k-state-selected');//removing the state selected
			}
		});
		//if (currentRow.selected) {
		//    currentRow.selected = false;
		//    grid.table.find("tr[data-uid='" + currentRow.uid + "']").removeClass("k-state-selected");//removing the state selected
		//}
		//else {
		//    currentRow.selected = true;
		//    grid.table.find("tr[data-uid='" + currentRow.uid + "']").addClass("k-state-selected");//adding the state selected
		//}
	}

	//*** upgrade for ipad support - 27 sep 2018 - pgpatrudu 
	if (EHRisMobile.any()) {
		//ev.preventDefault();
		if (hasValue(ev) && hasValue(ev.event) && hasValue(ev.event.target)) {
			ev.preventDefault();
		}
	}

}



//(function () {
//var myapp = angular.module("myapp", ["kendo.directives"]);
//$("[data-toggle='tooltip']").tooltip();
// Sample directive.  Activate it by passing my-grid attribute to
// the div which constructs the grid.  It expects your div to also
// have a kendo-grid attribute, to activate the Kendo UI directive
// for creating a grid.
angular.module('EMR.Admin').directive('emrGrid', ['$compile', function ($compile) {
	return ({
		restrict: 'A',
		scope: true,
		priority: -1,
		controller: ['$scope', function ($scope) {
			window.crap = $scope;

			//*******************************************************************************************************
			//** select all check box ng-click event handler,                                                       *
			//** which is used to handle select/deselect all the checkboxes existing in grid rows                   *
			//**----------------------------------------------------------------------------------------------------*
			//** delegate call to common handler                                                                    *
			//*******************************************************************************************************
			$scope.toggleSelectAll = function (ev) {
				toggleSelectAllHandler(ev);
			};

			//*******************************************************************************************************
			//** single select in the grid                                                                          *
			//** which is used to handle select/deselect single checkbox existing in grid row                       *
			//**----------------------------------------------------------------------------------------------------*
			//** delegate call to common handler                                                                    *
			//*******************************************************************************************************
			$scope.toggleSelectSingle = function (ev, currentRow) {
				toggleSelectSingleHandler(ev, currentRow);
			};

		}],


		link: function ($scope, $element, $attrs) {

			//try {



			var groupColumnsLength = 0; // to hold the grouped columns count for current grid
			var options = angular.extend({}, $scope.$eval($attrs.options)); // getting grid options from grid attributes


			if ($scope.$eval($attrs.options) != undefined && $scope.$eval($attrs.options) != null) {

				$scope.$eval($attrs.options).resizable = true;

				////////////// #############   MOBILE VIEW EVENT BLOCKING FOR SCROLL PREVENTION BLOCK START ###################################

				//added by mahesh p on 12/10/2018
				// when it is mobile version then going to remove the draggable move selection event on data bound of the grid 
				// since we are unable to scroll inside the grid in mobile view 
				//if (EHRisMobile.any()) {

				//	if (hasValue(options.selectable) &&
				//		options.selectable.indexOf("multiple") > -1 &&
				//		$scope.$eval($attrs.options).dataBound) {

				//		//holding the previous bound event calling here
				//		$scope.$eval($attrs.options).dataBoundEHR = $scope.$eval($attrs.options).dataBound;

				//		//writing the new definition for bound event 
				//		$scope.$eval($attrs.options).dataBound = function (e) {

				//			//writtent try-catch block here to prevent stopping the functionality for executing next blocks,
				//			// since there may be logic for bound event

				//			//clering the move event,
				//			try {
				//				this.selectable.userEvents._events.move = null;//disable marquee
				//			} catch (e) {

				//			}

				//			//calling the holded back function with args required 
				//			//this.options.dataBoundEHR.call(this, e);

				//			//calling the holded back function with args required 
				//			this.options.dataBoundEHR.apply(this, arguments);

				//		};

				//	}
				//}

				////////////// #############   MOBILE VIEW EVENT BLOCKING FOR SCROLL PREVENTION BLOCK END ###################################

			}

			//var previousChangeFn = $scope.$eval($attrs.options).change;

			//$scope.$eval($attrs.options).change = function (e) {

			//	e.sender.select();

			//	previousChangeFn(e);
			//};

			//var options = $scope.$eval($attrs.kOptions);
			var data = null; // to hold the grid columns which are defined in options

			var gridID = '#' + $attrs.id;

			var alreadyColumnAdded = [];

			//checkig whether a column is already added or not
			if (hasValue(options) && hasValue(options.columns)) {
				alreadyColumnAdded = $.grep(options.columns, function (column) {
					return column.isshowCheckBoxColumnaddedcentralized == true;
				});
			}

			//getting showCheckBoxColumn property from grid options
			//showCheckBoxColumn==true then only we will add the select all checkbox title and template
			if (options.showCheckBoxColumn && (!hasValue(alreadyColumnAdded) || alreadyColumnAdded.length <= 0)) {

				//// create templates according to device type (desktop or mobile) 
				//var rowTemplate = "";
				//var hdrTemplate = "";

				//// desktop templates
				//if (!EHRisMobile.any()) {
				//    rowTemplate = "<span style='padding : 6px;' class='text-center'><input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/></span>";
				//    hdrTemplate = "<span style='padding : 6px;' class='text-center'><input type='checkbox' class='selectAllChkBox'  ng-click='toggleSelectAll($event)' /></span>";
				//}


				//// mobile templates
				//if (EHRisMobile.any()) {
				//    rowTemplate = "<div id='" + $attrs.id + "_touchSurface1' kendo-touch k-on-touchstart='toggleSelectSingle(kendoEvent,dataItem);'><input type='checkbox' ng-model='dataItem.selected' /></div>";
				//    hdrTemplate = "<div id='" + $attrs.id + "_touchSurface2' kendo-touch k-on-touchstart='toggleSelectAll(kendoEvent);'><input type='checkbox' class='selectAllChkBox' /></div>";
				//}

				var emrGridTemplates = genEMRGridTemplates($attrs.id);


				//to add the new checkbox record as the first column.
				if (hasValue(options.selectable) && (options.selectable.toLowerCase() == "single" || options.selectable.toLowerCase() == "single row")) {
					options.columns.unshift({
						//template: "<span style='padding : 6px;' class='text-center'><input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/></span>",
						//title: "<input type='checkbox' title='Select all' ng-click='toggleSelectAll($event)' />",

						template: emrGridTemplates.rowTemplate,
						width: "35px",
						locked: options.isLockedGrid,
						isshowCheckBoxColumnaddedcentralized: true
					});
				}
				else {
					options.columns.unshift({
						//template: "<span style='padding : 6px;' class='text-center'><input type='checkbox' ng-model='dataItem.selected' ng-click='toggleSelectSingle($event,dataItem)'/></span>",
						//title: "<span style='padding : 6px;' class='text-center'><input type='checkbox' class='selectAllChkBox'  ng-click='toggleSelectAll($event)' /></span>",

						template: emrGridTemplates.rowTemplate,
						headerTemplate: emrGridTemplates.hdrTemplate,
						width: "35px",
						locked: options.isLockedGrid,
						isshowCheckBoxColumnaddedcentralized: true
					});
				}
			}

			//getting columns from grid options
			data = options.columns;

			if (options == undefined || options.dataSource == undefined || options.dataSource._group == undefined)
				groupColumnsLength = 0; ////set groupColumnsLength to group coluns lengh
			else
				groupColumnsLength = options.dataSource._group.length;



			//if (options.dataSource.group == undefined) //if group columns are not defined
			//    groupColumnsLength = 0; //set groupColumnsLength to zero
			//else if (options.dataSource.group.length == undefined) //if group columns are defied but length is undefinded i.e. group column is defined as like a object with single column but not like an array.
			//    groupColumnsLength = 1;//set groupColumnsLength to 1
			//else
			//    groupColumnsLength = options.dataSource.group.length; ////set groupColumnsLength to group coluns lengh

			// if (options.mobileRedirect) {
			//if style tag is not found for the current grid element then only we will construct the styles and add to the current element



			//false always as guided by mohan sir on 12/29/2016
			options.mobileRedirect = false;

			if (!hasValue(options.mobileRedirect) || (hasValue(options.mobileRedirect) && options.mobileRedirect == true)) {

				if ($element.find("style").length === 0) {
					var css = '<style>@media only screen and (max-width: 500px),(max-device-width: 500px){\n'; //for mobile resolution ,(min-device-width: 768px) and (max-device-width: 1024px) and (orientation:portrait)
					css += '.hideSelectAll{display: block !important;}';
					css += gridID + ' table, ' + gridID + ' thead, ' + gridID + ' tbody, ' + gridID + ' th, ' + gridID + ' td, ' + gridID + ' tr {display: block;}';
					css += '/* Hide table headers (but not display: none;, for accessibility) */';
					css += gridID + ' thead tr {position: absolute;top: -9999px;left: -9999px; }';
					css += gridID + ' tr { border: 1px solid #ccc; }';
					css += gridID + ' td { /* Behave  like a "row" */ border: none;border-bottom: 1px solid #eee; position: relative;padding-left: 50% !important;min-height: 25px !important;}';
					css += gridID + ' td:before {/* Now like a table header */position: absolute;/* Top/left values mimic padding */top: 6px;left: 6px;width: 45%;padding-right: 10px;white-space: nowrap;}';
					if (options.groupable || groupColumnsLength > 0) //if grouping is applyed for the current grid
					{
						css += gridID + ' .k-group-cell{display: none !important;}'; //removing grouping cell
						css += gridID + ' .k-grouping-row td{padding-left: 0px !important;}'; // removing left padding for the grouping row
					}
					css += '/*Label the data*/';

					if (options.showCheckBoxColumn) //if showCheckBoxColumn is true in grid options
					{

						//adding select all checkbox to show in mobile resolution for only multi select grid
						if (options.selectable == "multiple" || options.selectable == "multiple row") {
							$element.before('<div class="hideSelectAll" style="display:none;">Select All: <input type="checkbox" class="selectAllChkBox" onclick="toggleSelectAllForJS(\'' + $attrs.id + '\',this)" /></div>');
						}



						if (options.groupable || groupColumnsLength > 0)//if grouping is applyed for the current grid
						{
							css += gridID + ' td:nth-of-type(' + (groupColumnsLength + 1) + '):before { content: "Select"; }'; //applying Select as caption before checkbox row (which is available after all group rows)

							//setting row caption for each data field except group rows
							for (var i = 1; i < data.length; i++) {
								var style = '' +
									gridID + ' td:nth-of-type(' + (i + groupColumnsLength + 1) + '):before {' +
									'content: "' + data[i].title + '";' +
									'}\n';
								css += style;
							}
						}
						else {
							css += gridID + ' td:nth-of-type(1):before { content: "Select"; }'; //applying Select as caption before checkbox row (which is available as first row)

							//setting row caption for each data field
							for (var i = 1; i < data.length; i++) {
								var style = '' +
									gridID + ' td:nth-of-type(' + (i + 1) + '):before {' +
									'content: "' + data[i].title + '";' +
									'}\n';
								css += style;
							}
						}
					}
					else //if showCheckBoxColumn is false/undefined in grid options
					{
						if (options.groupable || groupColumnsLength > 0)//if grouping is applyed for the current grid
						{
							//setting row caption for each data field except group rows
							for (var i = 0; i < data.length; i++) {
								var style = '' +
									gridID + ' td:nth-of-type(' + (i + groupColumnsLength + 1) + '):before {' +
									'content: "' + data[i].title + '";' +
									'}\n';
								css += style;
							}
						}
						else {
							//setting row caption for each data field
							for (var i = 0; i < data.length; i++) {
								var style = '' +
									gridID + ' td:nth-of-type(' + (i + 1) + '):before {' +
									'content: "' + data[i].title + '";' +
									'}\n';
								css += style;
							}
						}
					}

					css = css + '} \n';


					//added by mahesh  p for lower resolutions other than 449px
					css = css + '@media (min-width:150px) and (max-width:449px){ ' + gridID + ' td:before{text-overflow:ellipsis;overflow-x:hidden} } \n';

					css = css + gridID + ' .k-grouping-header{display: none !important;}';
					//css = css + 'div[data-role="grid"] .k-group-cell, div[data-role="grid"] .k-group-col{width: 1px !important;}';                    
					css = css + '</style>';
					if (data.length > 1)
						$element.html(css); //adding css to the current element
				}

			}
			//}
			//catch (e) {

			//}

			//}
		}
	});
}])


/**
Dear visitor:
 
Once you are done trying to 'understand' this function,
and have realized what a terrible mistake that was,
please increment the following counter as a warning
to the next guy:
 
total_hours_wasted_here = 2
**/

//###################### RESORT  GRID WHEN GRID CONTAIN GROUPING AND SERVER PAGING ######################
//*********PURPOSE :   THIS METHOD IS USED TO SORT THE GRID WHEN GRID CONTAINS GROUPING AND SERVER PAGING
//******CREATED BY :   ABDUL RAHIMAN
//******CREATED ON:   08/02/2018
var resortGridRowsWhenGrouped = function (gridObj) {
	var sort = gridObj.dataSource.sort();
	if (!sort || !sort.length)
		return;
	sort = sort[0];
	var curGroup = [];

	function sortRows(rows) {
		if (rows.length < 2)
			return;

		var first = rows[0],
			prepared = rows.map(function (el) {
				var di = gridObj.dataItem(el);
				return {
					row: el,
					data: di,
					oldIndex: gridObj._data.indexOf(di)
				};
			}),
			firstPrepared = prepared[0],
			ordered = prepared.sort(function (a, b) {
				var av = a.data[sort.field];
				var bv = b.data[sort.field];
				return av < bv ? -1 : (av > bv ? 1 : 0);
			});


		if (sort.dir === 'desc') {
			ordered = ordered.reverse();
		}

		for (var i = 0; i < ordered.length; i++) {
			var cur = ordered[i];
			if (cur.row === first) {
				for (var j = ordered.length - 1; j > i; j--) {
					cur = ordered[j];
					cur.row.insertAfter(first);
				}
				break;
			}
			cur.row.insertBefore(first);
		}

		for (i = 0; i < ordered.length; i++) {
			gridObj._data[firstPrepared.oldIndex + i] = ordered[i].data;
		}
	}

	gridObj.tbody.children().each(function (i, el) {
		var $el = $(el);
		if ($el.hasClass('k-grouping-row')) {
			curGroup.length && sortRows(curGroup);
			curGroup = [];
		} else {
			curGroup.push($el);
		}
	});
	curGroup.length && sortRows(curGroup);
};
//###################### RESORT  GRID WHEN GRID CONTAIN GROUPING AND SERVER PAGING ######################
//})();
